import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const dateTime = {
    sportItemDate: (date, format = 'D MMM, h:mm A', timeZone = 'Asia/Kolkata') => {
        return dayjs.utc(date).tz(timeZone).format(format);
    },
    NotInplaySportItemDateOnly(date, format = 'DD MMM') {
        if(dayjs(date).isSame(dayjs(), 'day')) return 'Today'
        else return this.sportItemDate(date, format)
    },
    convertUnixDate: (date, format = 'DD MMM YYYY HH:mm:ss') => {
        return dayjs.unix(date).format(format)
    },
    convertDate: (date, format = 'DD MMM YYYY HH:mm:ss') => {
        return dayjs(date).format(format);
    },
    currentTimestamp: () => {
        return dayjs().unix();
    },
    getcurrentDate: () => {
        return dayjs(new Date()).format('YYYY-MM-DD');
    },
    getDateSaperatedByDays: (days, date = new Date(), format = 'YYYY-MM-DD' ) => {
        return dayjs(date).subtract(days, 'day').format(format);
    },
    convertOnlyTime: (time) =>{
        return dayjs(time, "HH:mm").format("hh:mm A");
    },
    convertUtcDate: (date) => {
        return dayjs.utc(date);
    },
     // Wallet
     getUTCTime: (format = 'HH:mm:ss') =>{
        return dayjs.utc().format(format)
    },
    convertToTimestamp(date) {
        return dayjs(date).unix();
    },
    getPreviousDate: (day = 1, format = 'YYYY-MM-DD') => {
        return dayjs().subtract(day, 'day').format(format);
    },
    getcurrentTime: (format = 'HH:mm:ss') => {
        return dayjs().format(format);
    },
    // Matka
    isCurrentDateInRange: (startDate, endDate) => {
        const today = dayjs().startOf('day');
        const tomorrow = today.add(1, 'day');
    
        const start = dayjs(startDate).startOf('day');
        const end = dayjs(endDate).startOf('day');
    
        if (start.isSame(today) && end.isSame(today)) {
            return 'Today';
        } else if (start.isSame(tomorrow) && end.isSame(tomorrow)) {
            return 'Tomorrow';
        } else if (start.isBefore(today) || end.isBefore(today)) {
            return start.format('DD-MM-YYYY');
        }
    },
    getDateForMatka(date, format="DD/MM/YYYY hh:mm A") {
        return dayjs.utc(date).add(5, 'hours').add(30, 'minutes').format(format);
    },
    getLocalDate:(date, format = 'DD MMM hh:mm A') => {
        const localDate = dayjs.utc(date).local().format(format);
        return localDate;
    },
     isTomorrow(date) {
    const eventDate = dayjs(date);
    const tomorrowDate = dayjs().add(1, 'day').startOf('day');
    return eventDate.isSame(tomorrowDate, 'day');
    },
    isToday(date) {
        const eventDate = dayjs(date);
        const todayDate = dayjs().startOf('day');
        return eventDate.isSame(todayDate, 'day');
    },
    getDateAddedByDays: (days, date = new Date(), format = 'YYYY-MM-DD' ) => {
        return dayjs(date).add(days, 'day').format(format);
    },
    convertDateToTimstamp(date) {
        return dayjs(date).unix();
    },
    convertUnixTimeStampToLocalTime(date, format = 'DD MMM YYYY HH:mm:ss') {
        return dayjs.unix(date).add(5, 'hours').add(30, 'minutes').format(format)
    }
    
} 

export default dateTime